import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import ClassIcon from '@material-ui/icons/Class'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import RefIcon from '@material-ui/icons/Info'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DiceIcon from '@material-ui/icons/Casino'
import NamesDcbIcon from '@material-ui/icons/ImportContacts'
import { NavLink } from 'react-router-dom'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder'
import WarningIcon from '@material-ui/icons/Warning'
import ExitToApp from '@material-ui/icons/ExitToApp'
import PeopleIcon from 'material-ui/svg-icons/social/people'
import School from 'material-ui/svg-icons/social/school'
import ActionAssignmentInd from 'material-ui/svg-icons/action/assignment-ind'
import LibraryBooks from '@material-ui/icons/LibraryBooks'
import GroupWork from '@material-ui/icons/GroupWork'
import LocalHospital from '@material-ui/icons/LocalHospital'
import Timer from '@material-ui/icons/Timer'
import BubbleChart from '@material-ui/icons/BubbleChart'
import { connect } from 'react-redux'
import {
  Keyword,
  PreRegistration,
  Chemical,
  Drug,
  InteractionType,
  Interaction,
  Probability,
  ImageTime,
  Cids,
} from '../icons'
import RateReview from 'material-ui/svg-icons/maps/rate-review'
import { authActions } from '../actions'
import { permissions } from '../utils'
import jwt_decode from 'jwt-decode'

const drawerWidth = 240

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    backgroundColor: '#002d72',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuItem: {
    padding: 0,
    display: 'block',
    height: 'auto',
  },
  menuLink: {
    display: 'flex',
    textDecoration: 'none',
    padding: '12px 16px',
    '& > svg': {
      color: 'rgba(0, 0, 0, 0.54) !important',
    },
    '&.menu-link-active': {
      borderRight: '2px solid #002d72',
      '& > div h3': {
        color: '#002d72',
      },
      '& > svg': {
        color: '#002d72 !important',
      },
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
    [theme.breakpoints.down('xs')]: {
      width: '0.1px',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    minWidth: '260px',
    '-webkitOverflowScrolling': 'touch',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  toolBarRight: {
    marginLeft: 'auto',
    margin: '0 16px',
  },
  icon: {
    marginLeft: '8px',
  },
  versionLabel: {
    marginTop: 'auto',
    width: drawerWidth,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '& > p': {
      color: 'rgba(0, 0, 0, 0.5)',
      fontSize: '13px',
      textAlign: 'center',
    },
  },
})

class Layout extends React.Component {
  state = {
    open: false,
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  getMainContentStyles = () => {
    const { safeArea = true } = this.props
    const styles = {}
    if (!safeArea) {
      styles.padding = 0
    }
    Object.freeze(styles)
    return styles
  }

  render() {
    const { classes, theme, children, token, toolBarRight: ToolBarRight } = this.props

    const mainContentStyles = this.getMainContentStyles()

    return (
      <div className={classes.root}>
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.open}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(classes.menuButton, this.state.open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="title" color="inherit" noWrap>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}
              >
                Gestor de Conteúdo Informed
              </div>
            </Typography>
            {ToolBarRight ? (
              <div className={classes.toolBarRight}>
                <ToolBarRight />
              </div>
            ) : null}
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
          }}
          open={this.state.open}
        >
          <div className={classes.toolbar}>
            <IconButton onClick={this.handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </div>
          <Divider />
          <MenuList>
            {!!permissions.canRead({ token, functionality: 'conteudos' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/conteudos"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <LibraryBooks />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Conteúdos" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'preCadastros' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/pre_cadastros"
                  exact
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <PreRegistration />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Pré-cadastros"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'usuarios' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/usuarios"
                  exact
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Usuários" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'perfis' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/perfis"
                  exact
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <GroupWork />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Perfis" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'especialidades' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/especialidades"
                  exact
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <School />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Especialidades"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'autores' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/autores"
                  exact
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <ActionAssignmentInd />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Autores" />
                </NavLink>
              </MenuItem>
            )}

            {!!permissions.canRead({ token, functionality: 'autores' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/vetorizacao-livros"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <BubbleChart />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Vetorização"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'palavrasChave' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/palavras-chave"
                  exact
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Keyword />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Palavras-chave"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'avaliacoes' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/avaliacoes"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <RateReview />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Avaliações" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'laboratorios' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/laboratorios"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Chemical />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Laboratórios"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'tiposmedicamentos' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/tiposmedicamentos"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <LocalHospital />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Tipos Meds."
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'gravidades' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/gravidades"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <WarningIcon />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Gravidades" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'classificacoes_medicamentos' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/classificacoes_medicamentos"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <CreateNewFolderIcon />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Class. Meds."
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'classificacoes_atc' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/classificacoes_atc"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <ClassIcon />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Classificações ATC"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'medicamentos' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/medicamentos"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Drug />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Medicamentos"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'referencias' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/referencias"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <RefIcon />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Referências"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'probabilidades' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/probabilidades"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Probability />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Probabilidades"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'nomesDcb' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/nomesdcb"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <NamesDcbIcon />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Nomes DCB" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'cids' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/cids"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Cids />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="CIDs" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'interacoes' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/interacoes"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Interaction />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Interações" />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'interacoes_tipo' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/interacoes_tipo"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <InteractionType />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Interações Tipo"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'tempos_leitura' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/tempo_de_leitura"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <Timer />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Tempo de leitura"
                  />
                </NavLink>
              </MenuItem>
            )}
            {!!permissions.canRead({ token, functionality: 'imagens_minutos' }) && (
              <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
                <NavLink
                  to="/imagens_minutos"
                  activeClassName={'menu-link-active'}
                  className={classes.menuLink}
                >
                  <ListItemIcon className={classes.icon}>
                    <ImageTime />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Imagens Minutos"
                  />
                </NavLink>
              </MenuItem>
            )}
            <MenuItem className={classes.menuItem} onClick={this.handleDrawerClose}>
              <NavLink
                to="/sair"
                exact
                activeClassName={'menu-link-active'}
                className={classes.menuLink}
              >
                <ListItemIcon className={classes.icon}>
                  <ExitToApp />
                </ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} inset primary="Sair" />
              </NavLink>
            </MenuItem>
          </MenuList>
          <div className={classes.versionLabel}>
            <p>versão {process.env.REACT_APP_PACKAGE_VERSION}</p>
          </div>
        </Drawer>
        <main className={classes.content} style={mainContentStyles}>
          <div className={classes.toolbar} />
          {children}
        </main>
      </div>
    )
  }
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
})

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(authActions.logout())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(Layout))



// WEBPACK FOOTER //
// ./src/components/Layout.js